import { useState } from "react";
import {
  showErrorToastMsg,
  showSuccessToastMsg,
} from "../../utility/ToastMessage";
import { changeStudentPasswordAPI } from "../../services/portal/admin/studentService";
import { changeMyPasswordAPI } from "../../services/portal/student/studentService";

const StudentResetPasswordManage = ({ student, isAdminView = false }) => {
  const [changingPassword, setChangingPassword] = useState(false);
  const [changePasswordData, setChangePasswordData] = useState({
    password: "",
    confirmPassword: "",
  });

  const handleChangePasswordChange = (e) => {
    const { name, value } = e.target;
    setChangePasswordData({
      ...changePasswordData,
      [name]: value,
    });
  };

  const handleSubmitChangePassword = async (e) => {
    e.preventDefault();

    if (!changePasswordData.password) {
      showErrorToastMsg("Please enter password");
      return;
    }

    if (changePasswordData.password.length < 8) {
      showErrorToastMsg("Password must be at least 8 characters long");
      return;
    }

    if (changePasswordData.password !== changePasswordData.confirmPassword) {
      showErrorToastMsg("Passwords do not match");
      return;
    }

    setChangingPassword(true);

    try {
      var params = {
        password: changePasswordData.password,
      };

      var res;
      if (isAdminView) {
        params.userId = student.UserId;
        res = await changeStudentPasswordAPI(params);
      } else {
        res = await changeMyPasswordAPI(params);
      }

      if (res && res.IsSuccessful) {
        showSuccessToastMsg(res.Message || "Password changed successfully");
        setChangePasswordData({
          password: "",
          confirmPassword: "",
        });
      } else {
        showErrorToastMsg(res?.Message || "Failed to change password");
      }
    } catch (error) {
      console.error("Error changing password:", error);
      showErrorToastMsg("Failed to change password");
    } finally {
      setChangingPassword(false);
    }
  };

  if (student === null) {
    return (
      <div className="bg-white rounded-lg shadow-md p-6 mb-6 border-l-4 border-primary-600"></div>
    );
  }

  return (
    <div>
      <h4 className="text-lg font-medium text-gray-900 mb-4">Reset Password</h4>
      <form onSubmit={handleSubmitChangePassword} className="max-w-md">
        <div className="mb-4">
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 mb-1">
              New Password <span className="text-red-500">*</span>
            </label>
            <input
              type="password"
              name="password"
              value={changePasswordData.password}
              onChange={handleChangePasswordChange}
              placeholder="Enter new password (min. 8 characters)"
              className="text-sm font-medium w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              required
              minLength={8}
            />
          </div>

          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Confirm Password <span className="text-red-500">*</span>
            </label>
            <input
              type="password"
              name="confirmPassword"
              value={changePasswordData.confirmPassword}
              onChange={handleChangePasswordChange}
              placeholder="Confirm new password"
              className="text-sm font-medium w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              required
              minLength={8}
            />
          </div>
        </div>

        <div className="flex justify-end space-x-3">
          <button
            type="button"
            onClick={() => {
              setChangePasswordData({
                password: "",
                confirmPassword: "",
              });
            }}
            disabled={changingPassword}
            className="px-4 py-2 bg-gray-300 text-gray-700 rounded-lg hover:bg-gray-400 disabled:opacity-50 font-medium"
          >
            Clear
          </button>
          <button
            type="submit"
            disabled={changingPassword}
            className="px-4 py-2 bg-primary-600 text-white rounded-lg hover:bg-primary-700 disabled:opacity-50 font-medium"
          >
            {changingPassword ? "Resetting..." : "Reset Password"}
          </button>
        </div>
      </form>
    </div>
  );
};

export default StudentResetPasswordManage;
